export const VAULT_NOT_ACTIVE_MESSAGE = 'Für Ihre Organisation ist noch kein aktiver Vault eingerichtet.';

export function isVaultNotActive(error: any): boolean {
  return error?.error?.code === 'OPENBAO_APPROLE_CREDENTIALS_NOT_FOUND';
}

export function keystoreErrorMessage(error: any, fallback: string): string {
  if (isVaultNotActive(error)) return VAULT_NOT_ACTIVE_MESSAGE;
  // Technical backend details are not actionable for users.
  if (error?.status === 401 || error?.status === 403) {
    return 'Sie haben keine Berechtigung für diesen Vault. Bitte wenden Sie sich an die Administration Ihrer Organisation.';
  }
  return fallback;
}
